// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userRequest: ['filter'],
  userSuccess: ['data'],
  userFailure: ['err'],

  userCountRequest: ['filter'],
  userCountSuccess: ['data'],
  userCountFailure: ['err'],

  userCreateRequest: ['data'],
  userCreateSuccess: null,
  userCreateFailure: ['err'],

  userUpdateRequest: ['data'],
  userUpdateSuccess: null,
  userUpdateFailure: ['err'],

  userDeleteRequest: ['id'],
  userDeleteSuccess: null,
  userDeleteFailure: ['err'],

  userListRequest: ['data'],
  userListSuccess: null,
  userListFailure: ['err']
})

export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  user_count: [],
  err: null,
  processing: false,
  success: null,
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, success: null})

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const countSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    user_count: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.USER_SUCCESS]: success,
  [Types.USER_REQUEST]: request,
  [Types.USER_FAILURE]: failure,

  [Types.USER_COUNT_SUCCESS]: countSuccess,
  [Types.USER_COUNT_REQUEST]: request,
  [Types.USER_COUNT_FAILURE]: failure,

  [Types.USER_CREATE_SUCCESS]: manipulateSuccess,
  [Types.USER_CREATE_REQUEST]: manipulateRequest,
  [Types.USER_CREATE_FAILURE]: manipulateFailure,

  [Types.USER_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.USER_UPDATE_REQUEST]: manipulateRequest,
  [Types.USER_UPDATE_FAILURE]: manipulateFailure,

  [Types.USER_DELETE_SUCCESS]: manipulateSuccess,
  [Types.USER_DELETE_REQUEST]: manipulateRequest,
  [Types.USER_DELETE_FAILURE]: manipulateFailure,

  [Types.USER_LIST_SUCCESS]: manipulateSuccess,
  [Types.USER_LIST_REQUEST]: manipulateRequest,
  [Types.USER_LIST_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/UserRedux.js